import React from 'react';

export default function TermsPageFr() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Conditions d'utilisation de Radiomonitor.net</h1>
      <p>
        Les présentes Conditions d'utilisation (« Conditions ») régissent l'accès et l'utilisation du service Radiomonitor.net (« Service »).
        En utilisant le Service, vous confirmez accepter ces Conditions dans leur intégralité.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. Dispositions générales</h2>
      <p>Radiomonitor.net est un service en ligne d'analytique, de monitoring et d'outils associés pour les radios en ligne.</p>
      <p>L'accès au Service est accordé après lecture et acceptation des présentes Conditions.</p>
      <p>L'administration peut modifier les Conditions ; les mises à jour sont publiées sur le site et entrent en vigueur dès leur mise en ligne.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Fourniture des services</h2>
      <p>Les services sont fournis sur la base d'un abonnement selon l'offre choisie ou un contrat individuel.</p>
      <p>Les données et rapports générés par le Service ont un caractère informatif et sont utilisés à la discrétion de l'utilisateur.</p>
      <p>Radiomonitor.net n'est pas responsable des facteurs externes (pannes d'opérateurs, services tiers, etc.) qui affectent le fonctionnement de la station.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Limitation de responsabilité</h2>
      <p>Nous mettons tout en œuvre pour assurer la stabilité, mais nous ne garantissons pas l'absence d'interruptions ou d'erreurs techniques.</p>
      <p>Le Service n'est pas responsable des pertes liées à l'utilisation ou à l'impossibilité d'utiliser les outils de Radiomonitor.net.</p>
      <p>L'utilisateur est seul responsable de la configuration de son matériel, de ses logiciels et de sa connexion Internet.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Paiement et abonnement</h2>
      <p>Les fonctionnalités payantes sont activées après le paiement du forfait ou du package choisi.</p>
      <p>Le paiement s'effectue via les services disponibles, y compris le prélèvement automatique (si activé).</p>
      <p>En cas de résiliation, les montants déjà versés pour la période en cours ne sont pas remboursés, sauf disposition contractuelle contraire.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Propriété intellectuelle</h2>
      <p>Le contenu, le code, les bases de données et le design du Service appartiennent à Radiomonitor.net ou à ses licenciés.</p>
      <p>Il est interdit de copier ou de diffuser les matériaux, algorithmes ou données statistiques sans autorisation écrite.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Confidentialité</h2>
      <p>Le Service collecte un volume minimal de données techniques (adresse IP, paramètres de connexion, statistiques d'utilisation) pour garantir son fonctionnement.</p>
      <p>Les données personnelles ne sont pas communiquées à des tiers, sauf obligations légales.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. Conservation des données utilisateur</h2>
      <p>En cas d'arrêt du paiement, les données sont conservées 30 jours calendaires après la fin de l'abonnement.</p>
      <p>À l'expiration de ce délai, les informations peuvent être supprimées sans possibilité de récupération.</p>
      <p>Pour les utilisateurs avec un abonnement continu de plus d'un an, la conservation est garantie au minimum pendant un an.</p>
      <p>Sur demande écrite et paiement supplémentaire, la période de conservation peut être prolongée ; les conditions sont convenues avec le support.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Suspension d'accès</h2>
      <p>Radiomonitor.net peut suspendre ou limiter l'accès en cas de violation des Conditions ou des exigences légales.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Contacts</h2>
      <p>
        Pour toute question ou suggestion, contactez l'administration du Service :
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
